import { ProductColor } from '@aloft/toolkit-sui';

import { PLACEHOLDER } from '../consts.ts';
import { ViewMode } from '../types.ts';
import { DetailLineWithValue } from './DetailLineWithValue.tsx';

export function ModeAwareDetailLine({
  text,
  costValue,
  adj,
  viewMode,
  topBorder = false,
}: {
  text?: string;
  costValue?: string;
  adj?: { value: string; color: ProductColor };
  viewMode: ViewMode;
  topBorder?: boolean;
}) {
  if (viewMode === 'cost') {
    return <DetailLineWithValue text={text ?? PLACEHOLDER} value={costValue} />;
  }

  return (
    <DetailLineWithValue
      text={text ?? PLACEHOLDER}
      value={adj?.value}
      valueColor={adj?.color}
      topBorder={topBorder}
    />
  );
}
